import { render } from "./braConfig.vue?vue&type=template&id=f7bb9244&ts=true"
import script from "./braConfig.vue?vue&type=script&lang=ts"
export * from "./braConfig.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__